import React, { Component } from 'react';
import Select from "react-select";

const OPERATIONS = [
    { value: 'suma', label: 'Suma' },
    { value: 'promedio', label: 'Promedio' },
    { value: 'maximo', label: 'Maximo' },
    { value: 'minimo', label: 'Minimo' },
    { value: 'contador', label: 'Contador' },
    { value: 'valor', label: 'Valor' },
    { value: 'ultimo', label: 'Ultimo' },
    { value: 'primero', label: 'Primero' },
];

class FormCreate extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;

        const agg = props.modeEdit && props.aggregation ? props.aggregation : null;

        this.state = {
            format_source_id: agg && agg.format_source_info ? agg.format_source_info.id : "",
            question_target_id: agg && agg.question_target_info ? agg.question_target_info.id : "",
            question_source_id: agg && agg.question_source_info ? agg.question_source_info.id : "",
            operation: agg ? agg.operation : "",

            selectedFormatSource: agg && agg.format_source_info
                ? { label: agg.format_source_info.name, value: agg.format_source_info.id }
                : null,
            selectedQuestionTarget: agg && agg.question_target_info
                ? { label: agg.question_target_info.name, value: agg.question_target_info.id }
                : null,
            selectedQuestionSource: agg && agg.question_source_info
                ? { label: agg.question_source_info.name, value: agg.question_source_info.id }
                : null,
            selectedOperation: agg
                ? OPERATIONS.find(op => op.value === agg.operation) || null
                : null,

            targetQuestions: [],
            sourceQuestions: [],
            sourceFormats: [],
        };
    }

    componentDidMount = () => {
        this.loadTargetQuestions();
        this.loadSourceFormats();
        if (this.state.format_source_id) {
            this.loadSourceQuestions(this.state.format_source_id);
        }
    }

    loadTargetQuestions = () => {
        fetch(`/formatos/data_questions/${this.props.format.id}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(r => r.json())
        .then(data => {
            this.setState({
                targetQuestions: data.steps_questions.map(q => ({
                    label: q.question, value: q.id, question_type: q.question_type
                }))
            });
        });
    }

    loadSourceFormats = () => {
        fetch(`/formatos/get_format_aggregation_sources/${this.props.format.id}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(r => r.json())
        .then(data => {
            this.setState({
                sourceFormats: data.data
            });
        });
    }

    loadSourceQuestions = (formatSourceId) => {
        fetch(`/formatos/data_questions/${formatSourceId}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(r => r.json())
        .then(data => {
            this.setState({
                sourceQuestions: data.steps_questions.map(q => ({
                    label: q.question, value: q.id, question_type: q.question_type
                }))
            });
        });
    }

    handleFormatSourceChange = (option) => {
        this.setState({
            selectedFormatSource: option,
            format_source_id: option ? option.value : "",
            selectedQuestionSource: null,
            question_source_id: "",
            sourceQuestions: [],
        });
        if (option) {
            this.loadSourceQuestions(option.value);
        }
    }

    handleQuestionTargetChange = (option) => {
        this.setState({
            selectedQuestionTarget: option,
            question_target_id: option ? option.value : "",
        });
    }

    handleQuestionSourceChange = (option) => {
        this.setState({
            selectedQuestionSource: option,
            question_source_id: option ? option.value : "",
        });
    }

    handleOperationChange = (option) => {
        this.setState({
            selectedOperation: option,
            operation: option ? option.value : "",
        });
    }

    handleSave = () => {
        const { format_source_id, question_target_id, question_source_id, operation } = this.state;
        if (!format_source_id || !question_target_id || !question_source_id || !operation) return;

        const body = {
            format_id: this.props.format.id,
            format_source_id,
            question_target_id,
            question_source_id,
            operation,
        };

        const url = this.props.modeEdit
            ? `/formatos/format_aggregations/${this.props.aggregation.id}`
            : '/formatos/format_aggregations';
        const method = this.props.modeEdit ? 'PATCH' : 'POST';

        fetch(url, {
            method,
            body: JSON.stringify(body),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(r => r.json())
        .then(data => {
            if (this.props.modeEdit && this.props.onUpdated) {
                this.props.onUpdated(data.register);
            } else if (this.props.onCreated) {
                this.props.onCreated(data.register);
            }
        });
    }

    render() {
        const canSave = this.state.format_source_id && this.state.question_target_id && this.state.question_source_id && this.state.operation;

        return (
            <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, padding: 16, marginBottom: 16, background: '#fafbfc' }}>
                <p style={{ fontSize: 13, color: '#666', margin: '0 0 16px 0' }}>
                    Configura una agregacion que calculara un valor desde los registros de un formato hijo y lo almacenara en una pregunta de este formato. El formato hijo puede estar enganchado como subformulario o tener una pregunta de tipo formato apuntando a este.
                </p>

                <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                    <div style={{ flex: 1 }}>
                        <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Formato fuente</label>
                        <Select
                            onChange={this.handleFormatSourceChange}
                            options={this.state.sourceFormats}
                            value={this.state.selectedFormatSource}
                            placeholder="Seleccione un formato fuente..."
                            className="link-form"
                            isClearable
                        />
                        <span style={{ fontSize: 11, color: '#999', marginTop: 4, display: 'block' }}>Subformulario o formato asociado del cual se agregaran los valores</span>
                    </div>

                    <div style={{ flex: 1 }}>
                        <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Operacion</label>
                        <Select
                            onChange={this.handleOperationChange}
                            options={OPERATIONS}
                            value={this.state.selectedOperation}
                            placeholder="Seleccione una operacion..."
                            className="link-form"
                            isClearable
                        />
                        <span style={{ fontSize: 11, color: '#999', marginTop: 4, display: 'block' }}>Tipo de calculo a realizar</span>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                    <div style={{ flex: 1 }}>
                        <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Pregunta objetivo</label>
                        <Select
                            onChange={this.handleQuestionTargetChange}
                            options={this.state.targetQuestions}
                            value={this.state.selectedQuestionTarget}
                            placeholder="Seleccione una pregunta..."
                            className="link-form"
                            isClearable
                        />
                        <span style={{ fontSize: 11, color: '#999', marginTop: 4, display: 'block' }}>Pregunta de este formato donde se guardara el resultado</span>
                    </div>

                    <div style={{ flex: 1 }}>
                        <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block' }}>Pregunta fuente</label>
                        <Select
                            onChange={this.handleQuestionSourceChange}
                            options={this.state.sourceQuestions}
                            value={this.state.selectedQuestionSource}
                            isDisabled={!this.state.format_source_id}
                            placeholder={!this.state.format_source_id ? "Seleccione un formato fuente primero" : "Seleccione una pregunta..."}
                            className="link-form"
                            isClearable
                        />
                        <span style={{ fontSize: 11, color: '#999', marginTop: 4, display: 'block' }}>Pregunta del formato fuente de donde se tomaran los valores</span>
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
                    <button className="btn btn-outline-danger btn-sm" onClick={this.props.onClose}>
                        Cancelar
                    </button>
                    {canSave && (
                        <button className="btn btn-info btn-sm" onClick={this.handleSave}>
                            {this.props.modeEdit ? "Actualizar" : "Crear"}
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

export default FormCreate;
